import { Routes } from '@angular/router';
import { HumanResourcesComponent } from './human-resources.component';
import { HrDashboardComponent } from './dashboard/dashboard.component';
import { DocumentTrackingComponent } from './document-tracking/document-tracking.component';
import { PersonalTrackingComponent } from './personal-tracking/personal-tracking.component';
import { NotificationsComponent } from './notifications/notifications.component';
import { EmployeeManagementComponent } from './employee-management/employee-management.component';
import { CVPoolComponent } from './cv-pool/cv-pool.component';
import { AddHrManagerComponent } from './add-hr-manager/add-hr-manager.component';
import { LoginComponent } from './login/login.component';
import { RegisterCompanyComponent } from './register-company/register-company.component';
import { ProfileComponent } from './profile/profile.component';
import { DepartmentManagementComponent } from './department-management/department-management.component';
import { AvatarComponent } from './avatar/avatar.component';
export const HUMAN_RESOURCES_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent
  },
 
  {
    path: '',
    component: HumanResourcesComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: HrDashboardComponent },
      { path: 'document-tracking', component: DocumentTrackingComponent },
      { path: 'cv-pool', component: CVPoolComponent },
      { path: 'personal-tracking', component: PersonalTrackingComponent },
      { path: 'employees', component: EmployeeManagementComponent },
      { path: 'notifications', component: NotificationsComponent },
      { path: 'add-hr-manager', component: AddHrManagerComponent },
      { path: 'profile', component: ProfileComponent },
      { path: 'register', component: RegisterCompanyComponent },
      { path: 'document-type', loadComponent: () => import('./document-type/document-type.component').then(m => m.DocumentTypeComponent) },
      { path: 'departments', component: DepartmentManagementComponent },
      { path: 'avatar', component: AvatarComponent },
    ]
  }
];
